import { fetchWithAuth } from "../lib/api";
import type { DashboardLeadRow } from "../lib/dashboardLeads";

/**
 * Ch76 · the Admin page's `leads.unclaimed` figure, delivered with the feed so
 * the widget and the truth band read ONE computation. `total` is all-time;
 * `in_feed` is how many of the returned rows carry `unclaimed: true`;
 * `outside_feed` is what the window/cap hid. `status: "unknown"` means the
 * backend could not derive it — render UNKNOWN, never zero.
 */
export interface UnclaimedLeadTruth {
  metric_id: string;
  definition_id: string;
  status: "ok" | "unknown";
  total: number | null;
  in_feed: number | null;
  outside_feed: number | null;
  note?: string;
}

export interface LeadOpportunityResponse {
  mode: "computed_on_read";
  read_only: true;
  scoring_version: string;
  window_days?: number;
  limit?: number;
  unclaimed?: UnclaimedLeadTruth;
  leads: DashboardLeadRow[];
}

export function fetchLeadOpportunities(
  days = 90,
  limit = 500
): Promise<LeadOpportunityResponse> {
  return fetchWithAuth<LeadOpportunityResponse>(
    `/analytics/lead-opportunities?days=${days}&limit=${limit}`
  );
}

export interface FirstRefusalSummary {
  mode: "computed_on_read";
  read_only: true;
  scoring_version: string;
  month: string;
  converted_total: number;
  converted_high_total: number;
  high_to_agent_path: {
    count: number;
    stated_monthly_rent_sum: number;
    budget_missing_count: number;
    leads: Array<{
      lead_id: string;
      owner_name: string | null;
      converted_at: string | null;
      score_at_arrival: number;
    }>;
  };
  high_to_admin_path_count: number;
  unknown_role_count: number;
  truncated: boolean;
  caveats: string[];
}

export function fetchFirstRefusalSummary(
  month?: string
): Promise<FirstRefusalSummary> {
  const query = month ? `?month=${month}` : "";
  return fetchWithAuth<FirstRefusalSummary>(
    `/analytics/first-refusal-summary${query}`
  );
}
